import { Transition } from "../../../core/flows/Transition";
import { CheckoutContext } from "../../CheckoutPage/Context/CheckoutContext";
import { PassengerDetailsContext } from "../../CheckoutPage/PassengerDetailsFlow/Context/PassengerDetailsContext";
import { PaymentContext } from "../../CheckoutPage/Payment/Context/PaymentContext";
import { SeatingMapContext } from "../../CheckoutPage/SeatingMap/Context/SeatingMapContext";
import { VoucherContext } from "../../CheckoutPage/Voucher/Context/VoucherContext";
import { UpgradeBookingContext } from "../Context/UpgradeBookingContext";

export class UpgradeBookingTransition extends Transition {
    constructor(entryStep: string, exitSteps: string[]) {
        super(entryStep, exitSteps);
    }

    onExecute(): string[] {
        const context = this.getCtx<UpgradeBookingContext>("upgradeBookingContext", this.entryStep);

        if (!context) {
            console.log("[Transition] No choice data available, using default exits");
            return this.exitSteps;
        }

        if (context?.routeTo?.includes("CheckoutFlow")) {
            const passengerDetailsContext = new PassengerDetailsContext()
            this.setCtx<PassengerDetailsContext>("passengerDetailsContext", passengerDetailsContext, this.entryStep)

            const voucherContext = new VoucherContext()
            this.setCtx<VoucherContext>("voucherContext", voucherContext, this.entryStep)

            const paymentContext = new PaymentContext()
            this.setCtx<PaymentContext>("paymentContext", paymentContext, this.entryStep)

            const seatingMapContext = new SeatingMapContext()
            this.setCtx<SeatingMapContext>("seatingMapContext", seatingMapContext, this.entryStep)

            const checkoutMapContext = new CheckoutContext()
            this.setCtx<CheckoutContext>("checkoutContext", checkoutMapContext, this.entryStep)
        }

        if (!(context.routeTo ?? []).every(step => this.exitSteps.includes(step))) {
            console.log(`[Transition] Invalid choice: ${this.getCtx("choice")}`);
            return [];
        }

        return [...(context?.routeTo ?? [])]
    }

}